import { useEffect } from 'react';
import { useAppContext } from 'components/Context/AppContext';
import clsx from 'clsx';
import { PaginationTable, TableWrapper } from 'components/Global';
import EmptyState from 'components/Global/EmptyState';
import LoadingSpinner from 'components/Global/LoadingSpinner';
import ActionButtons from 'components/Global/Table/ActionButtons';
import { deleteTestimonial, getTestimonials } from 'features/testimonial/actions';
import { trackEvent } from 'utils/analytics';

import { ReactComponent as ChatQuote } from 'icons/chat-quote.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getConfig } from 'config/runtime';

const imageUrl = getConfig('REACT_APP_IMAGES');

const COLUMN = [
  { header: 'No.', value: 'no' },
  { header: 'Foto Testimonial', value: 'photo' },
  { header: 'Nama', value: 'name' },
  { header: 'Username', value: 'username' },
  { header: 'Jenis Testimonial', value: 'type' },
];

const Influencers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const page = Number(searchParams.get('page')) || 1;

  const { setShowConfirmation, showToast } = useAppContext();

  const { list, isLoading } = useSelector((state) => state.testimonial);

  useEffect(() => {
    dispatch(getTestimonials({ type: 'influencers', page }));
  }, [page]);

  const pageNumber = (page, idx) => (page > 1 ? (page - 1) * 10 + idx : idx);

  const handleDetail = (e) => {
    const id = e.target.parentElement.parentElement.dataset['key'];
    navigate(`/testimonial/detail/${id}?page=${page}`);
  };

  const handleDelete = (e) => {
    const testimonialId = e.target.parentElement.parentElement.dataset['key'];
    if (!testimonialId) return;

    setShowConfirmation({
      message: 'Apakah anda yakin ingin menghapus data?',
      show: true,
      onClick: async () => {
        try {
          trackEvent('testimonial_deleted', { testimonial_id: testimonialId, source: 'influencers_list' });
          await dispatch(deleteTestimonial(testimonialId)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Menghapus data' });
          dispatch(getTestimonials({ type: 'influencers', page }));
        } catch (error) {
          showToast({ type: 'error', message: 'Gagal Menghapus data' });
        }
      },
    });
  };

  const handlePageChange = (newPage) => {
    const updatedParams = Object.fromEntries(searchParams.entries());
    updatedParams.page = newPage;
    setSearchParams(updatedParams);
  };

  const rows = 10 - list.testimonies?.length;

  const DATA = list?.testimonies?.map((item) => ({
    ...item,
    type: getTestimonialType(item.type),
    photo: imageUrl + item.photo,
  }));

  return (
    <div className="review">
      <TableWrapper title="Testimonial" icon={<ChatQuote width="25px" height="25px" />}>
        {isLoading ? (
          <LoadingSpinner />
        ) : list?.testimonies?.length ? (
          <>
            <div className={clsx('table')}>
              <table className="table-wrapper">
                <thead className="table-head">
                  <tr>
                    {COLUMN.map((item, i) => (
                      <th key={i}>{item.header}</th>
                    ))}
                    <th className="action-col">Action</th>
                  </tr>
                </thead>
                <tbody className="table-body">
                  {DATA.map((item, no) => (
                    <tr key={no}>
                      {COLUMN.map((col, idx) => {
                        if (col.value === 'no') {
                          return (
                            <td
                              key={idx}
                              data-type="no"
                              className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                            >
                              {pageNumber(page, no + 1)}
                            </td>
                          );
                        } else if (col.value === 'photo') {
                          return (
                            <td
                              key={idx}
                              data-type={col.value}
                              className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                              style={{ width: '215px', textAlign: 'center' }}
                            >
                              <div style={{ display: 'flex', justifyContent: 'center', padding: '18px 0' }}>
                                <img
                                  src={item[col.value]}
                                  style={{ width: '163px', height: '73px', objectFit: 'cover', borderRadius: '6px' }}
                                />
                              </div>
                            </td>
                          );
                        } else {
                          return (
                            <td
                              key={idx}
                              data-type={col.value}
                              className={col?.highlight_color ? `col-highlight-${col?.highlight_color}` : ''}
                            >
                              {item[col.value]}
                            </td>
                          );
                        }
                      })}
                      <td className="btn-action" data-type="actionButtons" data-key={!item.id ? item.code : item.id}>
                        <ActionButtons edit={handleDetail} />

                        <ActionButtons del={handleDelete} />
                      </td>
                    </tr>
                  ))}
                  {rows > 0 &&
                    [...Array(rows)].map((_, idx) => (
                      <tr key={idx}>
                        {COLUMN.map((_, idx) => (
                          <td key={idx}></td>
                        ))}
                        <td className="btn-action"></td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <PaginationTable
              currentPage={page}
              onPageChange={handlePageChange}
              totalCount={list?.pagination?.total_data}
            />
          </>
        ) : (
          <EmptyState />
        )}
      </TableWrapper>
    </div>
  );
};

export default Influencers;

export const getTestimonialType = (type) => {
  if (type === 'influencers') return 'Influencers';
  if (type === 'common_users') return 'Common Users';

  return '-';
};
